import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-color-profile-icon',
  templateUrl: './design-color-profile.component.html'
})
export class DesignColorProfileComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
